import { ApiCall, ParameterTypes } from '@lcms/api-definition';
import { AdminTrendingSearchTerm } from '../../../_models/admin/admin-trending-search-term';
import { SortType } from '../../../_models/admin/sort-type';
import endpoints from '../api-endpoint-definition.json';

export type TrendingSearchTermsResponse = AdminTrendingSearchTerm[]

const definition = new ApiCall<TrendingSearchTermsResponse>().post('trendingSearchTermsAdmin', { 
    route: endpoints.adminTrendingSearchTerms,
    params: {
        sort: {
            type: '' as SortType
        },
        filter: {
            type: ParameterTypes.String,
            optional: true
        },
        active: {
            type: ParameterTypes.Boolean,
            optional: true
        }
    }
})
export default definition;